import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from '../utils/functions';
import { reloadScriptSlider } from '../components/slider';

const $projectListEl = $('.project-insight');

$(function () {
    if ($projectListEl.length > 0) {
        $projectListEl.each(function () {
            projectList($(this));
        });
    }
});

const projectList = (listEl) => {
    // const filter = {
    //     limit: listEl.data('limit'),
    //     category: '',
    //     search: '',
    //     dateStart: '',
    //     dateEnd: '',
    //     lang: listEl.data('lang'),
    // };

    bindProjectFilter(listEl);
};

const reRenderList = async (element, filter, scrollTop = false) => {
    const data = await getEvents(filter);
    element.find('.event-insight__content').html(data.html);
    reloadScriptSlider();

    if (scrollTop === true) {
        smoothscroll(element, 'header');
    }
};

const bindProjectFilter = (element) => {
    element.on('click', '.project-categories__filter', function () {
        $('.project-card').hide();

        const $thisEl = $(this);
        let category = $thisEl.data('category');

        $('.category' + category).show();
    });

};

